import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';

@Component({
  selector:    'pay-empty-state',
  standalone:  true,
  imports:     [CommonModule, LucideIconsModule],
  templateUrl: './pay-empty-state.component.html',
  styleUrls:   ['./pay-empty-state.component.scss'],
})
export class PayEmptyStateComponent {
  @Input() icon:      string  = 'inbox';
  @Input() title:     string  = '';
  @Input() subtitle?: string;
  @Input() ctaLabel?: string;

  @Output() ctaClicked = new EventEmitter<void>();

  onCta(): void {
    this.ctaClicked.emit();
  }
}
